import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import T from '../../../i18n/i18n';

export const DiceCounterRow = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: #aaa;
    position: relative;
    width: 100%;
    text-align: center;
    opacity: 0;
    transition: all .5s ease 0s;

    &.show {
        opacity: 1;
    }
`;

export default ({counter}) => {

    const counterRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if(counterRef.current) {
                counterRef.current.classList.add('show');
            }
        }, 3000);
    }, []);

    return <DiceCounterRow ref={counterRef}>
        {counter.countSuccess}
        <T value={counter.countSuccess === 1 ? 'chat.success' : 'chat.success_plural'} />,  {counter.countCritical}
        <T value={counter.countCritical === 1 ? 'chat.critical' : 'chat.critical_plural'} />,  {counter.countFail}
        <T value={counter.countFail === 1 ? 'chat.fail' : 'chat.fail_plural'} />
    </DiceCounterRow>
}